<template>
	<div>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<modalSendEmailSerial ref="modalSendEmailSerial" @action="sendEmail"></modalSendEmailSerial>
		<div class="d-flex justify-space-between">
			<div class="text-h5" v-if="$route.name == 'list-sales-retail'">Data Penjualan Langsung</div>
			<div class="text-h5" v-else-if="$route.name == 'list-sales-retail-warehouse'">Data Penjualan Langsung Warehouse</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<router-link class="text-deco" :to="{ name: 'add-sales-retail' }" v-if="hasAccess('add-sales-retail')">
							<v-btn light depressed class="primary">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Penjualan</div>
							</v-btn>
						</router-link>
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mt-3" v-if="dropfilter">
					<v-col cols="12" class="px-4">
						<v-row>
							<v-col cols="12" md="3">
								<v-text-field dense outlined hide-details label="Kode Transaksi" v-model="codeSR.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-text-field dense outlined hide-details label="Kode Mitra" v-model="codeCustomer.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="menuDateCreate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalDibuat)" label="Tanggal Transaksi" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details></v-text-field>
									</template>
									<v-date-picker range color="primary" v-model="tanggalDibuat"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete v-if="$route.name == 'list-sales-retail-warehouse'" outlined dense hide-details v-model="sr_warehouse.value" :items="warehouseResults" label="Warehouse" item-text="warehouse_name" item-value="warehouse_id" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="9">
							</v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<v-card outlined v-if="listSR.length == 0 && srPagination" class="mt-3">
				<div class="py-3">
					<not-found></not-found>
				</div>
			</v-card>
			<div v-else>
				<v-row class="mr-0">
					<v-col cols="12" md="12" class="pb-0 pr-0" v-for="listsr in listSR" :key="listsr.sr_id">
						<v-card outlined>
							<v-list color="deep-purple lighten-5" class="pt-0 pb-0">
								<v-list-item dense>
									<v-list-item-content class="grey--text text--darken-2">
										Kode Penjualan {{ listsr.sr_code }}
									</v-list-item-content>
									<v-spacer></v-spacer>
									<v-btn small text depressed class="primary" @click="printSR(userData.user_warehouse_id, listsr.sr_code)">
										<v-icon>mdi-printer</v-icon>
										<div class="pl-2 text-capitalize">Print</div>
									</v-btn>
								</v-list-item>
							</v-list>
							<v-list-item>
								<v-list-item-content>
									<v-layout wrap>
										<v-flex xs6 sm3 md3 class="pr-3">
											<div class="body-2 oppacity-75">Kode Mitra</div>
											<div class="subtitle-2">{{ listsr.sr_buyer_network_mid }}</div>
											<div class="body-2 pt-3 oppacity-75">Nama Mitra</div>
											<div class="subtitle-2">{{ listsr.sr_buyer_name }}</div>
											<div v-if="$route.name == 'list-sales-retail-warehouse'" class="body-2 pt-3 oppacity-75">Warehouse</div>
											<div v-if="$route.name == 'list-sales-retail-warehouse'" class="subtitle-2">{{ listsr.warehouse_name }}</div>
										</v-flex>
										<v-flex xs6 sm5 md5 class="pr-3">
											<div class="body-2 oppacity-75">Tanggal Transaksi</div>
											<div class="subtitle-2">{{ listsr.sr_datetime | tanggaljam }}</div>
											<div class="body-2 pt-3 oppacity-75">Catatan Pembayaran</div>
											<div class="subtitle-2" v-html="listsr.sr_payment_note"></div>
										</v-flex>
										<v-flex xs6 sm4 md4 class="pr-3">
											<div class="body-2 oppacity-75">Nomor Handphone</div>
											<div class="subtitle-2">{{ listsr.sr_buyer_mobilephone }}</div>
											<div class="pt-5">
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="mr-2" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(listsr.sr_code)">
															<v-icon dark>mdi-text-box-search</v-icon>
														</v-btn>
													</template>
													<span>Detail</span>
												</v-tooltip>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="mr-2" fab dark x-small depressed color="primary" v-bind="attrs" v-on="on" @click.stop="showSendEmailModal(listsr.sr_code, listsr.sr_buyer_email)">
															<v-icon dark>mdi-email-send-outline</v-icon>
														</v-btn>
													</template>
													<span>Kirim Email Serial</span>
												</v-tooltip>
											</div>
										</v-flex>
									</v-layout>
								</v-list-item-content>
							</v-list-item>
							<div class="pt-2">
								<v-card tile elevation="0">
									<v-data-table :headers="headersProduct" :items="listsr.sr_detail" :items-per-page="1000" class="elevation-0 white-row" hide-default-footer>
										<template v-slot:item.sr_detail_quantity="{ item }">
											<div>{{ item.sr_detail_quantity | toNumber }}</div>
										</template>
										<template v-slot:item.sr_detail_product_price="{ item }">
											<div>Rp {{ item.sr_detail_product_price | toNumber }}</div>
										</template>
										<template v-slot:item.sr_detail_serial_string="{ item }">
											<div v-if="item.sr_detail_serial_type == 'digital'">{{ item.sr_detail_serial_digital_bv }} BV</div>
											<div v-else>{{ item.sr_detail_serial_string }}</div>
										</template>
									</v-data-table>
								</v-card>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
			<div class="pt-5">
				<v-row v-if="srPagination.total_page">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination v-model="page" @input="changePage" :length="srPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import modalDetail from '@/views/MLwarehouse/sr/DetailSR'
import modalPrint from '@/views/MLwarehouse/sr/PrintSR'
import modalSendEmailSerial from './components/ModalSendEmailSerial'
import { mapActions,  mapState, mapMutations } from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modalDetail, modalPrint, modalSendEmailSerial
	},
	data() {
		return {
			dialog: false,
			dialogPrint: false,
			dropfilter: false,
			menuDateCreate: false,
			loading: true,
			tanggalDibuat: [],
			page: 1,
			limit: 10,
			listLimit: [ 5, 10, 20, 50, 100 ],
			params: [],
			headersProduct: [
			{ text: 'Nama Produk', value: 'sr_detail_product_name', sortable: false, width: '30%' },
			{ text: 'Kode Produk', value: 'sr_detail_product_code', sortable: false, width: '15%' },
			{ text: 'Harga', value: 'sr_detail_product_price', sortable: false, align: 'center', width: '10%' },
			{ text: 'Jumlah', value: 'sr_detail_quantity', sortable: false, align: 'center', width: '10%' },
			{ text: 'Serial', value: 'sr_detail_serial_string', sortable: false, align: 'center', width: '35%' },
			],
			codeSR: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'sr_code'
			},
			codeCustomer: {
				value:'',
				comparison:'like',
				type:'string',
				field: 'sr_buyer_network_mid'
			},
			dateCreatedSR: {
				value: [],
				comparison: 'bet',
				type: 'date',
				field: 'sr_datetime'
			},
			sr_warehouse: {
				value: '',
				comparison: '=',
				type: 'string',
				field: 'sr_warehouse_id'
			},
		}
	},
	computed: {
		...mapState('sr', ['listSR', 'srPagination', 'warehouseResults']),
		...mapState('auth', ['userData']),
	},
	methods: {
		...mapActions('sr', ['getSR', 'getSRAll', 'approvalPayment', 'cancelSR', 'deleteSR', 'getDetailSR', 'exportSR', 'exportSRAll', 'getWarehouseOption', 'sendEmailSerial']),
		...mapMutations('sr', ['clearDataSR']),
		...mapActions('common', ['getLetterHeader']),

		getData() {
			if (this.$route.name == 'list-sales-retail')
				this.getSR(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
					this.loading = false
				})
			else if (this.$route.name == 'list-sales-retail-warehouse')
				this.getSRAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
					this.loading = false
				})
		},
		exportData() {
			if (this.$route.name == 'list-sales-retail')
				this.exportSR(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			else if (this.$route.name == 'list-sales-retail-warehouse')
				this.exportSRAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		countGrandtotal(item) {
			let total = 0
			item.forEach( (el) => {
				let price = el.sr_detail_product_price ? el.sr_detail_product_price : 0
				let quantity = el.sr_detail_quantity
				total += price * quantity
			});
			return total
		},
		addressText(customer_data) {
			var data = []
			if (customer_data) {
				if (customer_data.customer_address)
					data.push(customer_data.customer_address)
				if (customer_data.customer_subdistrict_name)
					data.push(customer_data.customer_subdistrict_name)
				if (customer_data.customer_city_name)
					data.push(customer_data.customer_city_name)
				if (customer_data.customer_province_name)
					data.push(customer_data.customer_province_name)
			}
			return data.join(', ')
		},
		cari() {
			this.params = []
			if(this.codeSR.value)
				this.params.push(this.codeSR)
			if(this.codeCustomer.value)
				this.params.push(this.codeCustomer)
			if (this.dateCreatedSR.value.length) {
				this.dateCreatedSR.value.sort()
				let date = this.dateCreatedSR.value.join('::')
				this.dateCreatedSR.value = date
				this.params.push(Object.assign({}, this.dateCreatedSR))
			}
			if (this.sr_warehouse.value)
				this.params.push(this.sr_warehouse)
			this.page = 1
			this.getData()
		},
		resetFilter() {
			this.codeSR.value = ''
			this.dateCreatedSR.value = ''
			this.codeCustomer.value= ''
			this.sr_warehouse = ''
			this.tanggalDibuat = []
			this.params = []
			this.limit = 10
			this.page = 1
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		getDetail(code) {
			this.getDetailSR(code).then(()=> {
				this.dialog = true
			})
		},
		async printSR(id, code) {
			await this.getLetterHeader({warehouse_id: id})
			await this.getDetailSR(code).then(()=> {
				this.dialogPrint = true
			})
		},
		showSendEmailModal(sr_code, email) {
			this.$refs.modalSendEmailSerial.showModal(sr_code, email)
		},
		async sendEmail(params) {
			let result = await this.sendEmailSerial(params)
			if (result == true)
				await this.$refs.modalSendEmailSerial.hideModal()
		}
	},
	created() {
		this.getData()
		this.getWarehouseOption()
		this.$store.dispatch('setPageTitle', `Penjualan Langsung`)
	},
	beforeDestroy() {
		this.clearDataSR()
	},
	watch: {
		tanggalDibuat(val) {
			this.dateCreatedSR.value = val
		},
		$route() {
			this.resetFilter()
		}
	}
};
</script>
